import * as React from 'react';

import './NavBar.css';

import Avatar from '../Elements/Avatar'
import SearchBox from './SearchBox'
import UserMenu from './UserMenu'

interface INavBarProps {
    onSearchTriggered: (searchString: string) => void;
    onSignOutRequested: () => void;
}

interface INavBarState {
    isUserMenuOpenened: boolean,
    imageUrl: string,

    isMobileSearchOpened: boolean
}

class NavBar extends React.Component<INavBarProps, INavBarState> {
    private mySearchBoxInstance: SearchBox | null;

    public constructor(props: INavBarProps) {
        super(props);

        this.mySearchBoxInstance = null;

        this.state = {
            isUserMenuOpenened: false,
            imageUrl: "../../Img/avatar.jpg",

            isMobileSearchOpened: false
        };
    }

    public componentWillMount() {
        this.setState({
            imageUrl: window.localStorage.getItem('imageUrl') as string
        });
    }

    public render() {
        return (
            <div className="NavBar">
                <div className="NavBar__menu">
                    <i className={"NavBar__menu__icon material-icons " + (this.state.isMobileSearchOpened ? "NavBar__deactivated" : "")}>menu</i>
                </div>

                <div className={"NavBar__logo-box " + (this.state.isMobileSearchOpened ? "NavBar__deactivated" : "")} />
                
                <div className={"NavBar__go-back " + (this.state.isMobileSearchOpened ? "" : "NavBar__deactivated")}>
                    <i className="NavBar__go-back__icon material-icons" onClick={this.backButtonClicked}>keyboard_arrow_left</i>
                </div>
                <div className={"NavBar__search-box-holder " + (this.state.isMobileSearchOpened ? "" : "NavBar__deactivated")}>
                    <SearchBox onSearchTriggered={this.props.onSearchTriggered} onRef={this.searchBoxRefed} />
                </div>

                <div className="NavBar__residual-fill" />

                <div className="NavBar__user-details-holder">
                    <Avatar size="medium" imageUrl={this.state.imageUrl} />
                    <div className="NavBar__expand">
                        <i className="material-icons" onClick={this.userMenuClicked}>keyboard_arrow_down</i>

                        {this.state.isUserMenuOpenened ? <UserMenu onSignOutRequested={this.props.onSignOutRequested} onClickOutside={this.userMenuClicked}/> : <div />}
                    </div>
                </div>

                <div className="NavBar__search">
                    <i className={"NavBar__search__icon material-icons " + (this.state.isMobileSearchOpened ? "NavBar__deactivated" : "")} onClick={this.searchButtonClickedMobile}>search</i>
                </div>
            </div>
        );
    }

    private searchBoxRefed = (searchBoxInstance: SearchBox | null) => {
        this.mySearchBoxInstance = searchBoxInstance;
    };

    private userMenuClicked = () => {
        this.setState({ isUserMenuOpenened: !this.state.isUserMenuOpenened });
    };

    private searchButtonClickedMobile = () => {
        this.setState({ isMobileSearchOpened: true });

        if(this.mySearchBoxInstance) {
            this.mySearchBoxInstance.focus();
        }
    };

    private backButtonClicked = () => {
        this.setState({ isMobileSearchOpened: false });
    };
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/App/Blocks/NavBar.tsx